interface Props {
    targetGroupIds?: number[];
    targetCount: number;
    groupNames: Map<number, string>;
}

const recipientsLabel = (count: number) => `${count} ${count === 1 ? 'recipient' : 'recipients'}`;

export const TargetCell = ({targetGroupIds, targetCount, groupNames}: Props) => {
    // Guard: older API responses may omit targetGroupIds — fall back to recipient count.
    const ids = targetGroupIds ?? [];
    if (ids.length === 0) {
        return <div className="text-ink-muted text-xs">{recipientsLabel(targetCount)}</div>;
    }

    const names = ids
        .map((id) => groupNames.get(id))
        .filter((name): name is string => Boolean(name));

    let primary: string;
    if (names.length === 0) {
        // Names not resolved yet (still loading) — fall back to a group count.
        primary = `${ids.length} ${ids.length === 1 ? 'group' : 'groups'}`;
    } else if (names.length === 1) {
        primary = names[0];
    } else {
        primary = `${names[0]} +${names.length - 1}`;
    }

    return (
        <div className="min-w-0">
            <div className="truncate text-xs font-medium text-ink" title={names.join(', ')}>
                {primary}
            </div>
            <div className="text-[11px] text-ink-muted">{recipientsLabel(targetCount)}</div>
        </div>
    );
};
